import {ComponentType, lazy, SVGProps} from 'react';

export type IconComponent = ComponentType<SVGProps<SVGSVGElement>>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type IconRegistry = Record<string, ComponentType<any>>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const importSvg = (loader: () => Promise<any>): ComponentType<any> =>
  lazy(() => loader().then((mod) => ({default: mod.default ?? mod})));

export const themeIcons: IconRegistry = {
  fallback: importSvg(() => import('./fallback.svg')),
  'navigation/arrow_upward': importSvg(() => import('./navigation/arrow_upward.svg')),
  'navigation/arrow_downward': importSvg(() => import('./navigation/arrow_downward.svg')),
};

export type ThemeIconKey = string;
